import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { Button } from 'ui-components/components/button';
import { Pill } from 'ui-components/components/pill';
import { noop } from 'ui-components/default-props/noop';
import marketplaceStepMessages from './messages';
import messages from '../../messages';
import style from './marketplace-list.module.less';

const MarketplaceListItem = ({ item, openMarketplaceModal, onClickAddStore }) => {
  const onClick = item.isAddStoreButton ? onClickAddStore : noop;

  const onConnectMarketplace = useCallback(() => {
    openMarketplaceModal(item);
  }, [item, openMarketplaceModal]);

  const renderActionMessage = () => {
    if (item.isAddStoreButton) {
      return (
        <Button theme='link'>
          <FormattedMessage {...marketplaceStepMessages.addAnotherMessage} />
        </Button>
      );
    }
    if (item.isConnected) {
      return <Pill className={style['connected-pill']} label={<FormattedMessage {...messages.connected} />} />;
    }
    return (
      <Button onClick={onConnectMarketplace} theme='primary'>
        <FormattedMessage {...messages.connect} />
      </Button>
    );
  };

  return (
    <div
      className={classNames(style['marketplace-item'], {
        [style['is-add-item']]: item.isAddStoreButton,
      })}
      onClick={onClick}
    >
      <div className={style.logo}>{item.logo}</div>
      {item.name && <div className={style.name}>{item.name}</div>}
      <div className={style.action}>{renderActionMessage()}</div>
    </div>
  );
};

MarketplaceListItem.propTypes = {
  item: PropTypes.shape({
    isAddStoreButton: PropTypes.bool,
    isConnected: PropTypes.bool,
    id: PropTypes.string,
    logo: PropTypes.node,
    name: PropTypes.node,
  }).isRequired,
  openMarketplaceModal: PropTypes.func.isRequired,
  onClickAddStore: PropTypes.func.isRequired,
};

export default MarketplaceListItem;
